import { LoadingIndicator } from '@Wonder-Cave/ui';
import { MessageTypeEnum } from '@gr/shared/enums';
import { ICampaignDetails } from '@gr/shared/models';
import PreviewMedia from '../shared/Media/PreviewMedia';
import { ExternalCampaignDetails } from './types';

interface ICampaignMessagePreviewProps {
  campaign?: Partial<ICampaignDetails> | Partial<ExternalCampaignDetails>;
  domain?: string;
}

const CampaignMessagePreview = ({ campaign, domain }: ICampaignMessagePreviewProps) => {
  return (
    <div className="p-12 ml-8 shadow-inner rounded-4xl bg-ice">
      <div
        className="pt-24 pl-4"
        style={{
          backgroundImage: `url(phone.svg)`,
          backgroundSize: '100% 100%',
          width: '299px',
          height: '592.949px',
        }}
      >
        <div className="pt-8 w-[270px] h-[391px] bg-white overflow-scroll">
          {!!campaign && !!campaign.mediaUrl && campaign.messageType === MessageTypeEnum.MMS && (
            <div className='ml-6 w-[75.3%] mb-1'>
              <PreviewMedia isMMSVideo={campaign.isMMSVideo} mediaUrl={campaign.mediaUrl} mediaName={campaign.mediaName} />
            </div>
          )}
          {!!campaign ? (
            campaign?.clickTrackingEnabled ? (
              <div className={`detail-bubble`}><p className='text-xs'>{campaign.message?.replace(/{{link}}/gi, domain + '/az2bx1').replace(/\|/g, ' ')}</p></div>
            ) :
              (<div className={`detail-bubble`}><p className='text-xs'>{campaign.message?.replace(/\|/g, ' ')}</p></div>
              )) : (
            <div className={`detail-bubble`}>
              <LoadingIndicator />
            </div>)
          }

        </div>
      </div>
    </div>
  );
};

export default CampaignMessagePreview;